import React, {useState, useEffect} from "react";
import useOnScreen from "../../components/UseOnScreen/UseOnScreen"; 
import "../About/QuoteSection.css";

// Função utilitária para embaralhar um array (algoritmo Fisher-Yates)
const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

const QuoteSection = () => {
  const [ref, isVisible] = useOnScreen({ threshold: 0.5, once: true }); // 50% do elemento visível dispara
  const quoteText = "Há algo do enigma humano que sempre me convocou: o que escapa, o que insiste, o " +
      "que não se explica! A psicanálise lacaniana é o campo onde esse enigma encontra " +
      "lugar por meio da palavra e é nela que sustento minha escuta clínica.";

  const characters = [...quoteText];
  const words = quoteText.split(/(\s+)/);
  const [randomOrder, setRandomOrder] = useState([]);

  useEffect(() => {
      // 🛑 Modificação: A condição agora é mais simples e confiável
      // Só executa se estiver visível E o randomOrder ainda não tiver sido preenchido
      if (isVisible && randomOrder.length === 0) {
          const indices = Array.from(words.keys());
          const shuffledIndices = shuffleArray([...indices]);
          
          // Dispara a re-renderização com a ordem, o que sairá do estado de carregamento
          setRandomOrder(shuffledIndices);
      }
  }, [isVisible, randomOrder.length, words.length]); // ⬅️ Adicione characters.length

  // Espera até que o array de ordem aleatória seja preenchido
  if (randomOrder.length === 0) {
    return (
      <div id="quote-section">
        <div className="quote-block">
          {/* Renderiza o texto sem animação enquanto espera, ou um spinner */}
          <p className="quote-text" ref={ref}>
            {quoteText}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div id="quote-section">
      <div className="quote-block">
        <p className="quote-text">
          {/* {characters.map((word, index) => { */}
          {words.map((word, index) => {
            const animationOrder = randomOrder.indexOf(index);
            const delay = animationOrder * 0.05;

            return (
              <span
                key={index}
                className="animated-word"
                style={{
                animationDelay: `${delay}s`
              }}>
                {word}
              </span>
            );
          })}
        </p>
      </div>
    </div>
  );
}

export default QuoteSection;